import Moveable from "react-moveable";
import { useRef } from "react";
import { PImg } from "../theme/BaseTheme";

export const MockupEditor = (props) => {
    const moveableRef = useRef(null);

    return (
        <div className="root" style={{ position: "absolute" }}>
            <div
                className="container"
                style={{
                    width: "600px",
                    height: "600px",
                    position: "relative",
                }}
            >
                <PImg
                    src={props.uploadedImage}
                    className="target"
                    ref={props.designImageRef}
                    style={{
                        width: "200px",
                        height: "200px",
                    }}
                />
                <Moveable
                    ref={moveableRef}
                    target={props.designImageRef}
                    bounds={{
                        left: -100,
                        top: -100,
                        right: -100,
                        bottom: -100,
                        position: "css",
                    }}
                    snappable={true}
                    onBound={(e) => {
                        console.log(e);
                    }}
                    edge={[]}
                    draggable={true}
                    origin={false}
                    originDraggable={false}
                    throttleDrag={1}
                    edgeDraggable={false}
                    startDragRotate={0}
                    throttleDragRotate={0}
                    onDrag={(e) => {
                        e.target.style.transform = e.transform;
                    }}
                    onDragOrigin={(e) => {
                        e.target.style.transformOrigin = e.transformOrigin;
                        e.target.style.transform = e.drag.transform;
                    }}
                    resizable={
                        props.enableEdit === true && props.editMode === "drag"
                    }
                    onResize={(e) => {
                        e.target.style.width = `${e.width}px`;
                        e.target.style.height = `${e.height}px`;
                        e.target.style.transform = e.drag.transform;
                    }}
                    rotatable={
                        props.enableEdit === true && props.editMode === "drag"
                    }
                    onRotate={(e) => {
                        e.target.style.transform = e.drag.transform;
                    }}
                    warpable={
                        props.enableEdit === true && props.editMode === "warp"
                    }
                    renderDirections={["nw", "ne", "sw", "se"]}
                    onWarp={(e) => {
                        e.target.style.transform = e.transform;
                        console.log(e.moveable.getRect());
                    }}
                />
            </div>
        </div>
    );
};
